/** Serie numerowane przedsięwzięć („EOP 210”, skrót „EOP 210”) — strona kliencka.
 *
 *  Lustro apps/enterprises/project_numbering.py i TYLKO dla podpowiedzi w formularzach:
 *  numer nadaje serwer, gdy skrót/nazwa zawierają `{N}` (atomowo, pod blokadą serii), więc
 *  dwie wygrane oznaczane równolegle nie dostaną tego samego numeru. */

export const NUMBER_PLACEHOLDER = "{N}";
const PLACEHOLDER_RX = /\{\s*N\s*\}/i;
/** Skrót, który wygląda jak numer w serii: „EOP”, „EOP 210”, „E25”, „EOP {N}”. */
const SERIES_SHORT_RX = /^\s*([A-Za-z]{1,6})\s*[-_ ]?\s*(\d{0,4}|\{\s*N\s*\})\s*$/i;

export function hasNumberPlaceholder(text: string): boolean {
  return PLACEHOLDER_RX.test(text);
}

/** Prefiks serii ze skrótu („EOP 210” → „EOP”), null gdy skrót nie jest numerem serii. */
export function seriesPrefixOf(shortName: string): string | null {
  const m = SERIES_SHORT_RX.exec(shortName);
  return m ? m[1].toUpperCase() : null;
}

/** Nazwa z prefiksem „<seria> {N}”: istniejący numer wiodący („EOP 210 Karsin”) jest
 *  podmieniany, nazwa bez numeru dostaje prefiks z przodu. */
export function nameWithPlaceholder(name: string, series: string): string {
  const lead = new RegExp(
    `^\\s*${series}\\s*[-_ ]?\\s*(\\d{1,4}|\\{\\s*N\\s*\\})(?!\\d)\\s*`,
    "i",
  );
  const rest = lead.test(name) ? name.replace(lead, "") : name.trim();
  return rest ? `${series} ${NUMBER_PLACEHOLDER} ${rest}` : `${series} ${NUMBER_PLACEHOLDER}`;
}
